module.exports = __webpack_public_path__ + "static/img/activitydetailsbg_mobile.e6ab2ebe.png";